import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBurger: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"burger, hamburger, sandwich "} maskId="square-filled-radius-0-stroke-1-IconBurger"><path d="M6.10783 4.72287C7.89185 3.45336 10.1288 3 12 3C13.8712 3 16.1082 3.45336 17.8922 4.72287C19.7013 6.01022 21 8.10754 21 11.2757V12H3V11.2757C3 8.10754 4.29874 6.01022 6.10783 4.72287Z" fill="currentColor"/><path d="M21 21V16H3V21H21Z" fill="currentColor"/><path d="M22 15V13H2V15H22Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBurger;
